// Datos ficticios compartidos entre páginas. Reemplazar por RPCs reales cuando
// se conecte el backend.

// === Clientes ejemplo === //
export interface Cliente {
  nombre: string
  cedula: string
  whatsapp: string
  plaza: 'Guayaquil' | 'Quito' | 'Manta' | 'Cuenca' | 'Loja'
  saldoVencido: number
  diasMora: number
  idCredito: number
  articulo?: string
  compromisosIncumplidos?: number
}

export const clientesSample: Cliente[] = [
  {
    nombre: 'MIELES CEDEÑO LIGIA ELENA',
    cedula: '0906368113',
    whatsapp: '+593 99 XXX 2466',
    plaza: 'Guayaquil',
    saldoVencido: 59.74,
    diasMora: 15,
    idCredito: 1869275,
    articulo: 'Refrigeradora',
    compromisosIncumplidos: 1,
  },
  {
    nombre: 'GREFA SALAZAR DANNY ALEXANDER',
    cedula: '1550091761',
    whatsapp: '+593 99 XXX 7640',
    plaza: 'Guayaquil',
    saldoVencido: 121.36,
    diasMora: 15,
    idCredito: 2050152,
    articulo: 'Televisor',
  },
  {
    nombre: 'GAVICA MERO SUSAN DENISSE',
    cedula: '0915068415',
    whatsapp: '+593 99 XXX 4426',
    plaza: 'Guayaquil',
    saldoVencido: 125.86,
    diasMora: 15,
    idCredito: 2080311,
    articulo: 'Lavadora',
  },
  {
    nombre: 'PABLO MENDOZA',
    cedula: '0908112233',
    whatsapp: '+593 99 XXX 5555',
    plaza: 'Guayaquil',
    saldoVencido: 340.75,
    diasMora: 45,
    idCredito: 2050124,
    articulo: 'Combo línea blanca',
    compromisosIncumplidos: 2,
  },
  {
    nombre: 'LUCÍA BENÍTEZ',
    cedula: '0913445566',
    whatsapp: '+593 99 XXX 1122',
    plaza: 'Quito',
    saldoVencido: 512.0,
    diasMora: 28,
    idCredito: 2041122,
  },
]

// === Campañas === //
export type CampanaTipo = 'preventiva' | 'mora' | 'reenvio'
export type Prioridad = 'P1' | 'P2' | 'P3' | 'P4' | 'P5'

export interface Campana {
  id: string
  nombre: string
  descripcion?: string
  tipo: CampanaTipo
  prioridad: Prioridad
  estado: 'activa' | 'pausada' | 'borrador'
  vigenciaDesde?: string
  vigenciaHasta?: string | 'siempre'
  tandasPorDia: string[]
  diasSemana: number[]
  maxMensajes: number
  template: { name: string; variables: string[] }
  filtros: Record<string, string>
  stats: {
    enviadasHoy: number
    personasHoy: number
    respondieronHoy: number
    totalMes: number
    costoMes: number
  }
}

export const campanas: Campana[] = [
  {
    id: 'c-mora-15d-gye',
    nombre: 'Mora 15 días Guayaquil',
    descripcion: 'Recordatorio a clientes con 15 días vencidos en plaza Guayaquil',
    tipo: 'mora',
    prioridad: 'P2',
    estado: 'activa',
    vigenciaHasta: 'siempre',
    tandasPorDia: ['10:00', '15:00'],
    diasSemana: [1, 2, 3, 4, 5],
    maxMensajes: 100,
    template: { name: 'mora_recordatorio_v1', variables: ['saldo_vencido', 'id_credito', 'dias_vencidos'] },
    filtros: {
      días_mora: '15',
      plaza: 'GUAYAQUIL',
      saldo_vencido: '$25-$500',
      cuotas_vencidas: '≥1',
    },
    stats: {
      enviadasHoy: 55,
      personasHoy: 55,
      respondieronHoy: 8,
      totalMes: 1100,
      costoMes: 13.8,
    },
  },
  {
    id: 'c-prev-nacional',
    nombre: 'Preventiva 1-5 días nacional',
    descripcion: 'Recordatorio pre-vencimiento (1 a 5 días antes de la cuota)',
    tipo: 'preventiva',
    prioridad: 'P4',
    estado: 'activa',
    vigenciaHasta: 'siempre',
    tandasPorDia: ['09:15'],
    diasSemana: [1, 2, 3, 4, 5],
    maxMensajes: 1200,
    template: {
      name: 'preventiva_recordatorio_v1',
      variables: ['nombre', 'dias_restantes'],
    },
    filtros: {
      días_previa: '1,2,3,4,5',
      plaza: 'todas',
      saldo_cuota: '≥$10',
    },
    stats: {
      enviadasHoy: 1169,
      personasHoy: 1169,
      respondieronHoy: 287,
      totalMes: 23380,
      costoMes: 292.25,
    },
  },
  {
    id: 'c-mora-30-quito',
    nombre: 'Mora extrema 30+ días Quito',
    descripcion: 'Fin de mes · últimas 72h de octubre',
    tipo: 'mora',
    prioridad: 'P1',
    estado: 'pausada',
    vigenciaDesde: '2026-10-29',
    vigenciaHasta: '2026-10-31',
    tandasPorDia: ['10:00', '14:00', '17:00'],
    diasSemana: [1, 2, 3, 4, 5],
    maxMensajes: 50,
    template: { name: 'mora_recordatorio_v1', variables: ['saldo_vencido', 'id_credito', 'dias_vencidos'] },
    filtros: { días_mora: '≥30', plaza: 'QUITO', saldo_vencido: '≥$100' },
    stats: { enviadasHoy: 0, personasHoy: 145, respondieronHoy: 0, totalMes: 0, costoMes: 0 },
  },
]

// === Cuentas Point oficiales === //
export const cuentasPoint = [
  { banco: 'Pichincha', tipo: 'Corriente', numero: '3077712404', activa: true },
  { banco: 'Guayaquil', tipo: 'Corriente', numero: '41205385', activa: true },
  { banco: 'ProduBanco', tipo: 'Corriente', numero: '02002031200', activa: true },
  { banco: 'Pacífico', tipo: 'Corriente', numero: '7554421086', activa: true },
  { banco: 'Internacional', tipo: 'Corriente', numero: '05005157', activa: true },
  { banco: 'Austro', tipo: 'Corriente', numero: '0450014981', activa: true },
  { banco: 'BanEcuador', tipo: 'Corriente', numero: '30001661', activa: true },
  { banco: 'Loja', tipo: 'Corriente', numero: '2900744821', activa: true },
  { banco: 'Solidario', tipo: 'Corriente', numero: '0600066927', activa: true },
]

// === Razones sociales aceptadas === //
export const razonesSociales = [
  { nombre: 'Supermercado de Computadoras Compubussines Cía. Ltda.', nota: 'Principal · RUC 0992523405001', activa: true },
  { nombre: 'POINT S.A.', nota: 'Nombre comercial corto', activa: true },
  { nombre: 'ALMACENES POINT', nota: 'Variante marca', activa: true },
]

// === Templates aprobados Meta === //
export const templates = [
  {
    name: 'mora_recordatorio_v1',
    category: 'UTILITY',
    status: 'APPROVED',
    body: 'Point recordatorio: cuota vencida $ {{1}}. Crédito #{{2}}. Días vencidos: {{3}}. Gracias.',
    variables: 3,
    costo: 0.0125,
  },
  {
    name: 'preventiva_recordatorio_v1',
    category: 'UTILITY',
    status: 'APPROVED',
    body: 'Point aviso: tu cuota vence en {{2}}. Gracias.',
    variables: 2,
    costo: 0.0125,
  },
  {
    name: 'pago_validado_v1',
    category: 'UTILITY',
    status: 'APPROVED',
    body: 'Point aviso: comprobante recibido $ {{1}}. Gracias.',
    variables: 1,
    costo: 0.0125,
  },
]

// === Agentes === //
export const agentes = [
  { nombre: 'Ana Vera', iniciales: 'AV', estado: 'online', chats: 142, resueltos: 133, tasa: 94, tiempo: 11, rating: 4.8 },
  { nombre: 'Luis Mora', iniciales: 'LM', estado: 'online', chats: 128, resueltos: 114, tasa: 89, tiempo: 15, rating: 4.6 },
  { nombre: 'María Gómez', iniciales: 'MG', estado: 'online', chats: 108, resueltos: 92, tasa: 85, tiempo: 17, rating: 4.5 },
  { nombre: 'Carlos Vera', iniciales: 'CV', estado: 'online', chats: 76, resueltos: 64, tasa: 84, tiempo: 19, rating: 4.3 },
  { nombre: 'Patricia Sosa', iniciales: 'PS', estado: 'offline', chats: 33, resueltos: 29, tasa: 88, tiempo: 13, rating: 4.7 },
] as const
